(ns core.message.model)

(defn has-handler-fn
  [handler]
  (fn [msg]
    (= handler (:message/response-handler msg))))

(defn find-messages
  ([entity]
   (find-messages entity identity))
  ([entity filter-fn]
   (->> entity
        :message/_target-entity
        (filter filter-fn))))
